import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { UsersIcon } from 'lucide-react';
const locations = ['Austin, TX', 'Denver, CO', 'Miami, FL', 'Portland, OR', 'Chicago, IL', 'Nashville, TN', 'Seattle, WA', 'Phoenix, AZ', 'Boston, MA', 'Atlanta, GA'];
const timeAgo = ['2 minutes ago', '5 minutes ago', '8 minutes ago', '12 minutes ago', '15 minutes ago', 'just now'];
export function UrgencyToast() {
  const [isVisible, setIsVisible] = useState(false);
  const [location, setLocation] = useState(locations[0]);
  const [time, setTime] = useState(timeAgo[0]);
  useEffect(() => {
    const showToast = () => {
      setLocation(locations[Math.floor(Math.random() * locations.length)]);
      setTime(timeAgo[Math.floor(Math.random() * timeAgo.length)]);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const initialDelay = setTimeout(showToast, 6000);
    const interval = setInterval(showToast, 22000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-246">
      {isVisible && <motion.div initial={{
      x: -400,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -400,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 20
    }} className="fixed bottom-6 left-6 z-50 max-w-sm" data-id="element-247">
          <div className="bg-white rounded-lg shadow-2xl border border-gray-200 p-4 flex items-center gap-3" data-id="element-248">
            <div className="flex-shrink-0 w-11 h-11 bg-green-500 rounded-full flex items-center justify-center" data-id="element-249">
              <UsersIcon className="w-5 h-5 text-white" data-id="element-250" />
            </div>
            <div className="flex-1" data-id="element-251">
              <p className="text-sm font-semibold text-[#1a1a2e]" data-id="element-252">
                A family from <span className="text-[#1a56db]" data-id="element-253">{location}</span>{' '}
                just purchased
              </p>
              <p className="text-xs font-medium text-gray-800" data-id="element-254">
                Screen-Free Kids Protocol
              </p>
              <p className="text-xs text-gray-400 mt-0.5" data-id="element-255">{time}</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}